import React, { ReactElement } from 'react'
import { box } from 'styled-system/patterns'

import { MindfulChefLogo } from '@mindfulchefuk/design-system/Logos/MindfulChefLogo'
import { MobileNav } from '@mindfulchefuk/features/Navigation/components/Header/shared'
import { NavLinkData } from '@mindfulchefuk/features/Navigation/interfaces'
import { useSignedOutNavMobileContext } from '../context/SignedOutNavMobileContext'
import { SignedOutNavMobileLinkList } from './SignedOutNavMobileLinkList'
import { SignedOutNavMobileBottomSection } from './SignedOutNavMobileBottomSection'

type TSignedOutNavMobile = {
  links: NavLinkData[]
}

export const SignedOutNavMobile = ({
  links,
}: TSignedOutNavMobile): ReactElement => {
  const { handleCloseMobileNav, isHamburgerOpen } =
    useSignedOutNavMobileContext()

  return (
    <MobileNav isOpen={isHamburgerOpen} onClose={handleCloseMobileNav}>
      <div
        className={box({
          px: 6,
          pb: 3,
          pt: 6,
          color: 'aubergine',
        })}
      >
        <MindfulChefLogo color="aubergine" height={28} mb={12} />
        <SignedOutNavMobileLinkList links={links} />
      </div>
      <SignedOutNavMobileBottomSection />
    </MobileNav>
  )
}
